import fb from '@/firebaseConfig';
import localStore from '@/localStore';

/*

  STATE

 */

const initialState = () => (
  {
    uid: null,
    profile: {
      name: '',
      email: '',
      photoUrl: '',
      emailVerified: false,
    },
    authProvider: '',
    type: 'free',
    hasViewedWelcome: false,
    marketingOptOut: false,
    loaded: false,
  }
);

const state = {
  ...initialState(),
};


/*

  GETTERS

 */

const getters = {
  isSignedIn: state => state.uid != null,
  isUserSet: state => state.uid != null && state.loaded,
  isAnonymousUser: state => state.uid && !state.profile.email,
  isAdminUser: state => state.type === 'admin',
  isPremiumUser: state => state.type === 'premium' || state.type === 'admin',
  isFreeUser: state => state.type !== 'premium' && state.type !== 'admin',
};


/*

  ACTIONS

 */

const actions = {

  init({ commit, dispatch }) {
    fb.auth.onAuthStateChanged((user) => {
      if (user) {
        // console.log('init onAuthStateChanged', user.uid, user);
        commit('setCurrentUser', user);
        dispatch('analytics/setUserId', user.uid, { root: true });

        fb.usersCollection.doc(user.uid)
          .onSnapshot(
            (doc) => {
              // console.log('User document updated: ', doc.data());
              const userData = doc.data();
              if (userData) {
                commit('favorites/setFavorites', userData.favoriteIds, { root: true });
                commit('dailyCards/setDailyCards', userData.dailyCards, { root: true });
                dispatch('dailyCards/init', null, { root: true });
                commit('setOtherUserData', userData);
                commit('setLoaded');
                dispatch('cards/init', null, { root: true });
                if (userData.profile && !userData.profile.email) {
                  dispatch('updateProfile');
                }
              } else {
                dispatch('cards/init', null, { root: true });
              }
            },
            (error) => {
              console.log('Error getting user', error);
              dispatch('cards/init', null, { root: true });
            },
          );
      } else {
        commit('clearUser');
      }
    });
  },

  signOut() {
    fb.auth.signOut();
    window.location.reload();
    // dispatch('cards/unsubscribeToCardSnapshots', null, { root: true });
    console.log('Signed out');
  },

  updateProfile({ commit }) {
    const { currentUser } = fb.auth;
    if (!currentUser) {
      return;
    }
    commit('setCurrentUser', currentUser);
    const { displayName, email, emailVerified, photoURL, uid } = currentUser;

    if (email) {
      fb.usersCollection.doc(uid)
        .update({
          profile: {
            name: displayName,
            email,
            emailVerified,
            photoURL,
          },
        })
        .catch((error) => {
          console.log('Error updating user', error);
        });
    }
  },

  saveMarketingOptOutToDB(context, choice = null) {
    const { currentUser } = fb.auth;
    let bool = choice;
    if (choice === null) {
      bool = localStore.getItem('marketingOptOut');
    }

    if (currentUser) {
      const { uid } = currentUser;
      fb.usersCollection.doc(uid)
        .set({
          marketingOptOut: !!bool,
        }, { merge: true })
        .catch((error) => {
          console.log('Error updating marketingOptOut', error);
        });
    }
  },

  updateHasViewedWelcome({ state }) {
    const { uid } = state;
    fb.usersCollection.doc(uid)
      .update({
        hasViewedWelcome: true,
      })
      .catch((error) => {
        console.log('Error updating hasViewedWelcome', error);
      });
  },
};


/*

  MUTATIONS

 */

const mutations = {

  setCurrentUser(state, user) {
    const { displayName, email, emailVerified, photoURL, uid, providerData } = user;
    state.uid = uid;
    state.profile = {
      name: displayName,
      email,
      emailVerified,
      photoURL,
    };
    if (providerData[0]) {
      state.authProvider = providerData[0].providerId || '';
    }
  },

  setOtherUserData(state, data) {
    const { type, hasViewedWelcome, marketingOptOut } = data;
    state.type = type;
    state.marketingOptOut = marketingOptOut || false;
    state.hasViewedWelcome = hasViewedWelcome || false;
  },

  clearUser(state) {
    Object.assign(state, initialState());
  },

  setLoaded(state) {
    state.loaded = true;
  },

};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
